import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapTrackerComponent } from 'src/app/pages/map-tracker/map-tracker.component'; // 👈 import your component

const routes: Routes = [
  { path: '', redirectTo: 'map-tracker', pathMatch: 'full' }, // optional: default route
  { path: 'map-tracker', component: MapTrackerComponent }      // 👈 your map route
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
